<template>
  <div class="question-guide-mobile">
    <template v-if="guideContent" v-html="guideContent"></template>
    <p v-else class="font-size-18 secondary-color-txt text-center">Nội dung đang cập nhật!</p>
  </div>
</template>

<script>
import { getGuideQuestion } from './../_api'
export default {
  name: 'QuestionGuide',
  data() {
    return {
      guideContent: ''
    };
  },
  computed: {
    questionId () {
      return parseInt(this.$route.params.id)
    }
  },
  mounted () {
    this.getGuideData()
  },
  beforeDestroy () {
    this.guideContent = ''
  },
  methods: {
    getGuideData() {
      getGuideQuestion(this.questionId).then(res => {
        if (res && res.guideContent) {
          this.guideContent = res.guideContent
        }
      })
    }
  }
};
</script>

<style lang="scss">
.question-guide-mobile img {
  max-width: 100%;
  height: auto;
}
</style>
